import React from "react";
import ItemBox from "./ItemBox/ItemBox";
import useProductItem from "./useProductItem";

const ProductItem = ({ data }) => {
  const { add_to_cart, addLoading } = useProductItem();  
  return (
    <React.Fragment>
      <ItemBox data={data} add_to_cart={add_to_cart} addLoading={addLoading} />
    </React.Fragment>
  );
};

export default ProductItem;
